<template>
  <page-component
    url="projects_other"
    entity-name="project_other"
    entity-title="Проекты НДС и ВП"
    :parent-url="[
      { to: '/projects_other', text: 'Проекты НДС и ВП'}
    ]"
    :tabs="[
      ['', 'Основное', 0],
      ['discussion', 'Обсуждение', 0],
      ['map', 'Карта работ', 0]
    ]"
  />
</template>

<script>
  export default {
    props: [],
    data: function () {
      return {
      }
    }
  }
</script>